import { render, staticRenderFns } from "./UseCouponDialog.vue?vue&type=template&id=5c10b2a7&scoped=true"
import script from "./UseCouponDialog.vue?vue&type=script&lang=ts"
export * from "./UseCouponDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10b2a7",
  null
  
)

export default component.exports